var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "baseAccordion",
      class: [_vm.bemBlock, _vm.expanded ? "expanded" : ""]
    },
    [
      _c(
        "button",
        {
          ref: "baseAccordionButton",
          class: [_vm.bemElement("title"), "btn", "btn--primary"],
          attrs: {
            "aria-expanded": [_vm.expanded ? "true" : "false"],
            "data-interaction": "expand",
            "data-interaction-relation": "sibling"
          },
          on: { click: _vm.toggleExpand }
        },
        [_c("h2", [_vm._v(_vm._s(_vm.title))])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [_vm.bemElement("content"), "interaction--expand"],
          attrs: { "data-interaction-dependant": "true" }
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.contentAssetContent) }
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }